import { render, staticRenderFns } from "./TopDepositRanking.vue?vue&type=template&id=fabfb206&scoped=true"
import script from "./TopDepositRanking.vue?vue&type=script&lang=js"
export * from "./TopDepositRanking.vue?vue&type=script&lang=js"
import style0 from "./TopDepositRanking.vue?vue&type=style&index=0&id=fabfb206&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fabfb206",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonsNuxtImage: require('/app/components/Commons/NuxtImage.vue').default})
